export const links = {
  support: 'https://support.outreach.io/hc/en-us/signin?utm_source=or&utm_medium=dd&utm_campaign=pltfm'
}
